import { useForm, Controller } from "react-hook-form";
import { Card, Text, TextInput } from "@mantine/core";
import { IconPencil } from "@tabler/icons";
import { useTranslation } from "next-i18next";
import { useColors } from "../../../../hooks/colors/useColors";
import { useProfile } from "./useProfile";
import { MyButton } from "../../../UI/my-button/MyButton";
import { MyH1 } from "../../../UI/my-h1/MyH1";
import { useUser } from "../../../../hooks/react-query/useUser";
import { isPhone } from "../../../../constants/env";
import dynamic from "next/dynamic";

const MyPhone = dynamic(
  () => import("./../../../UI/phone/MyPhone").then((mod) => mod.MyPhone),
  {
    ssr: false,
  }
);

export function ProfileForm(props: { open: boolean; closeModal: () => void }) {
  const { user } = useUser();
  const { colors } = useColors();
  const { open, closeModal } = props;
  const { error, processing, editProfile } = useProfile();
  const { i18n } = useTranslation("common");

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: user?.user ? user?.user?.displayName : "",
      email: user?.user ? user?.user.email : "",
      phone: user?.user ? user?.user.phoneNumber : "",
    },
  });

  return (
    <Card
      radius="xl"
      withBorder
      style={{ width: isPhone ? "96vw" : 600, zIndex: 0 }}
      className="my-6 hover:cursor-pointer hover:shadow-2xl"
    >
      <MyH1 centerText>{i18n.t("user.edit-profile")}</MyH1>
      {open && (
        <form
          onSubmit={handleSubmit(async (data) => {
            await editProfile(data, errors, props.closeModal);
          })}
        >
          <TextInput
            error={errors.name?.message}
            withAsterisk
            className="mb-4"
            type="text"
            label={i18n.t("login.name")}
            // @ts-ignore
            placeholder={i18n.t("login.name")}
            {...register("name", {
              minLength: {
                value: 3,
                message: i18n.t("login.nameError"),
              },
              maxLength: {
                value: 99,
                message: i18n.t("login.nameError"),
              },
            })}
          />
          <TextInput
            error={errors.email?.message}
            withAsterisk
            className="mb-4"
            type="email"
            label={i18n.t("login.email")}
            placeholder="your@email.com"
            {...register("email", {
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: i18n.t("login.invalidEmail"),
              },
            })}
          />
          <Controller
            name="phone"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <MyPhone
                className="mt-4"
                withBorder
                hideIcon
                // @ts-ignore
                value={user?.user?.phoneNumber}
                required
                // @ts-ignore
                label={i18n.t("phone")}
                field="phone"
                setFormValue={setValue}
                errors={errors.phone?.message}
                phone={field.value ? field.value : undefined}
                stringValue
              />
            )}
          />

          {error.length > 1 && (
            <Text className="mt-4" color={colors.danger}>
              {error}
            </Text>
          )}
          <MyButton
            fullWidth
            disabled={processing}
            loading={processing}
            icon={<IconPencil />}
            submit
            className="w-full mt-4"
            title={i18n.t("submit")}
            textColor="white"
            color={colors.primary}
            onClick={() => {}}
          />
        </form>
      )}
    </Card>
  );
}
